import { ButtonProps } from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { StyledClearButton } from "./styled";

type ClearButtonProps = {
  onClearFilters: () => void;
} & ButtonProps;

const ClearButton: FC<ClearButtonProps> = ({ onClearFilters }) => {
  return (
    <StyledClearButton onClick={onClearFilters} className="clear-filter">
      <Typography variant="bodyMMedium">Clear filter</Typography>
    </StyledClearButton>
  );
};

export default ClearButton;
